import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum EditorPlatformApplicationContainerErrorCode {
  ApplicationLoadError = 'ApplicationLoadError',
  ApplicationFetchError = 'ApplicationFetchError',
  ApplicationExecuteError = 'ApplicationExecuteError',
}

class EditorPlatformApplicationContainerError extends BaseError<EditorPlatformApplicationContainerErrorCode> {
  state: Partial<{
    url: string;
    appDefinitionId: string;
    apiMethod: string;
    apiType: string;
  }> = {};

  constructor(
    message: string,
    code: EditorPlatformApplicationContainerErrorCode,
  ) {
    super(message, code, 'EP Application Container Error');
  }

  withUrl(url: string) {
    this.state = { ...this.state, url };
    return this;
  }

  withAppDefinitionId(appDefinitionId: string) {
    this.state = { ...this.state, appDefinitionId };
    return this;
  }

  withApiMethod(apiMethod: string) {
    this.state = { ...this.state, apiMethod };
    return this;
  }

  withApiType(apiType: string) {
    this.state = { ...this.state, apiType };
    return this;
  }
}

export const createEditorPlatformApplicationContainerError = createErrorBuilder<
  EditorPlatformApplicationContainerErrorCode,
  EditorPlatformApplicationContainerError
>(EditorPlatformApplicationContainerError);
